import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import newsService from '@services/newsService';
import { NewsArticle } from '../../types/portfolio';

const LatestNews: React.FC = () => {
  // Tri-state: undefined = loading, null = failed/empty
  const [articles, setArticles] = useState<NewsArticle[] | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    newsService.getArticles({ language: 'tr', page_size: 4 })
      .then((res) => {
        if (cancelled) return;
        const rows = res.data?.results ?? [];
        setArticles(rows.length ? rows.slice(0, 4) : null);
      })
      .catch(() => { if (!cancelled) setArticles(null); });
    return () => { cancelled = true; };
  }, []);

  if (articles === null) return null;

  return (
    <div className="card p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-400">Son Haberler</span>
        <Link to="/news" className="text-[11px] text-accent-400 hover:text-accent-300">Tümü →</Link>
      </div>
      {articles === undefined ? (
        <div className="animate-pulse space-y-2 py-1">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-3.5 bg-white/[0.06] rounded w-5/6" />
          ))}
        </div>
      ) : (
        <div className="divide-y divide-white/[0.04]">
          {articles.map((a) => (
            <a
              key={a.id}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block py-2 hover:bg-white/[0.03] rounded px-1.5 -mx-1.5 transition-colors"
            >
              <p className="text-[13px] text-gray-300 line-clamp-1">{a.title}</p>
              <p className="text-[11px] text-gray-600 mt-0.5">{a.source_name}</p>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default LatestNews;
